<mat-form-field
  appearance="outline"
  subscriptSizing="dynamic"
  class="quick-search"
>
  <mat-label>Search orders</mat-label>
  <input
    matInput
    [ngModel]="searchTerm()"
    (ngModelChange)="onTermChange($event)"
    (keydown.enter)="onEnter($event, auto)"
    [matAutocomplete]="auto"
    placeholder="ID, address, name…"
    aria-label="Search orders"
  />
  <button
    matSuffix
    mat-icon-button
    type="button"
    [disabled]="!canSubmit()"
    (click)="submitSearch()"
    aria-label="Run search"
  >
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
    } @else {
      <mat-icon>search</mat-icon>
    }
  </button>
  <mat-autocomplete
    #auto
    autoActiveFirstOption
    panelClass="admin-quick-search-panel"
    [displayWith]="displayBlank"
    (optionSelected)="onOptionSelected($event.option.value)"
  >
    @if (loading()) {
      <mat-option disabled>
        <mat-spinner diameter="16"></mat-spinner>
        <span>Searching…</span>
      </mat-option>
    } @else if (errored()) {
      <mat-option disabled>Search failed — try again</mat-option>
    } @else if (hasSubmitted() && results().length === 0) {
      <mat-option disabled>No orders match "{{ searchTerm() }}"</mat-option>
    } @else {
      @for (row of results(); track row.OrderId) {
        <mat-option [value]="row" [disabled]="row.OrderId === currentOrderId()">
          <a
            class="quick-search__row"
            [class.quick-search__row--current]="
              row.OrderId === currentOrderId()
            "
            [href]="orderHref(row)"
            target="_self"
            rel="opener"
            (click)="onSelect(row, $event)"
          >
            <span class="quick-search__row-line1">
              #{{ row.OrderId }} — {{ row.OrderNumber }}
              @if (row.OrderId === currentOrderId()) {
                <span class="quick-search__current-tag">Current order</span>
              }
            </span>
            <span class="quick-search__row-line2">
              {{ row.PropertyAddress
              }}{{ row.PropertyCity ? ", " + row.PropertyCity : "" }}
              @if (row.FirstSignorName) {
                <span> · {{ row.FirstSignorName }}</span>
              }
            </span>
          </a>
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
